import listQuery from 'graphql/queries/product/ProductAliasListQuery.graphql';

const ProductAlias = {
  type: 'ProductAlias',
  notificationKey: 'reference',
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'reference',
    remoteFilter: true,
    placeholder: 'Search product aliases',
    pageView: false,
    asButton: false,
    formatter: 'dropdown',
  },
};

export default ProductAlias;
